import { Button } from "@mui/material";
import { Path } from "components/app.component";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  ActionButtonState,
  GlobalState,
  setNavigation,
  store,
} from "store/rentals-store";

export interface ActionButtonProps {
  testid?: string;
  className?: string;
}

export default function ActionButton({ testid, className }: ActionButtonProps) {
  const buttonState: ActionButtonState = useSelector(
    (state: GlobalState) => state.actionButton
  );
  const location = useLocation();
  const [buttonText, setButtonText] = useState("");
  const [nextLocation, setNextLocation] = useState("");

  useEffect(() => {
    switch (location.pathname) {
      case Path.Home: {
        store.dispatch(setNavigation(Path.Home));
        setButtonText("Continuar");
        setNextLocation(Path.Contact);
        break;
      }
      case Path.Contact: {
        store.dispatch(setNavigation(Path.Contact));
        setButtonText("Continuar");
        setNextLocation(Path.Delivery);
        break;
      }
      case Path.Delivery: {
        store.dispatch(setNavigation(Path.Delivery));
        setButtonText("Continuar");
        setNextLocation(Path.Payment);
        break;
      }
      case Path.Payment: {
        store.dispatch(setNavigation(Path.Payment));
        setButtonText("Agendar renta");
        setNextLocation(Path.Confirmation);
        break;
      }
    }
  }, [location]);

  if (location.pathname === Path.Confirmation) {
    store.dispatch(setNavigation(Path.Confirmation));
    return null;
  }

  function onClick() {
    store.dispatch(setNavigation(nextLocation));
  }

  return (
    // Each page component is in charge to handle form submission when the navigation is updated
    <Button
      loading={buttonState.isLoading}
      variant="contained"
      className={className}
      data-testid={testid}
      disabled={buttonState.disabled}
      onClick={onClick}
    >
      {buttonText}
    </Button>
  );
}
